<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <template slot="header">
          <h4 class="card-title">배너상세</h4>
        </template>
        <div class="row">
          <div class="col-sm-4">
            <div class="row">
              <label class="col-sm-4 col-form-label">한국어 이미지</label>
              <div class="col-sm-8">
                <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileUrl" @onChangeFileIds="onFileIdChange" />
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <label class="col-sm-4 col-form-label">영어 이미지</label>
              <div class="col-sm-8">
                <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileEnUrl" @onChangeFileIds="onFileIdEnChange" />
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <label class="col-sm-4 col-form-label">일본어 이미지</label>
              <div class="col-sm-8">
                <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileJaUrl" @onChangeFileIds="onFileIdJaChange" />
              </div>
            </div>
          </div>
        </div>
        <div class="row has-image">
          <label class="col-sm-2 col-form-label">링크</label>
          <div class="col-sm-10">
            <base-input placeholder="링크" v-model="link">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
          <label class="col-sm-2 col-form-label">노출타입</label>
          <div class="col-sm-10">
            <el-select v-if="bannerId" size="large" class="select-primary" placeholder="선택" v-model="type">
              <el-option v-for="option in types" class="select-primary" :value="option.type" :label="option.name" :key="option.name" />
            </el-select>
            <el-select v-else size="large" class="select-primary" placeholder="선택" v-model="type" multiple>
              <el-option v-for="option in types" class="select-primary" :value="option.type" :label="option.name" :key="option.name" />
            </el-select>
          </div>
          <label class="col-sm-2 col-form-label">시간설정</label>
          <div class="col-sm-3">
            <h4 class="card-title text-left">노출시작시간</h4>
            <div class="row">
              <div class="col-md-12 text-left">
                <base-input placeholder="시작시간">
                  <el-date-picker type="datetime" placeholder="시작시간" v-model="startTime"></el-date-picker>
                </base-input>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <h4 class="card-title text-left">노출종료시간</h4>
            <div class="row">
              <div class="col-md-12 text-left">
                <base-input placeholder="종료시간">
                  <el-date-picker type="datetime" placeholder="종료시간" v-model="endTime"></el-date-picker>
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </card>
      <base-button native-type="submit" type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
      <base-button v-if="bannerId && state === 1" @click="setBannerState(0)" type="default">숨김</base-button>
      <base-button v-if="bannerId" @click="setBannerState(-1)" type="danger">삭제</base-button>
      <base-button v-if="bannerId && state === 0" @click="setBannerState(1)" type="default">표시</base-button>
    </form>
  </div>
</template>
<script>
import { BaseInput, Card } from "@/components/index";
import BlipFileUploadZone from "@/components/BlipFileUploadZone";
import { HomepageBannerType } from "@/pages/Homepage/HomepageBannerType";

export default {
  components: {
    Card,
    BaseInput,
    BlipFileUploadZone,
  },
  async created() {
    if (this.$route.query.bannerId) {
      this.bannerId = Number(this.$route.query.bannerId);
      await this.getData();
    }
  },
  data() {
    return {
      bannerId: null,
      imageFileId: null,
      imageFileUrl: null,
      link: null,
      startTime: null,
      endTime: null,
      type: 0,
      state: 1,
      types: HomepageBannerType,
    };
  },
  methods: {
    onFileIdChange(newFileIds) {
      this.imageFileId = newFileIds[0];
    },
    onFileIdEnChange(newFileIds) {
      this.imageFileEnId = newFileIds[0];
    },
    onFileIdJaChange(newFileIds) {
      this.imageFileJaId = newFileIds[0];
    },

    async getData() {
      return this.$axios.get(`/homepage/banners/${this.bannerId}`).then((res) => {
        const data = res.data.data;
        if (data) {
          this.imageFileId = data.imageFileId;
          this.imageFileEnId = data.imageFileEnId;
          this.imageFileJaId = data.imageFileJaId;
          this.link = data.link;
          this.startTime = data.startTime;
          this.endTime = data.endTime;
          this.state = data.state;
          this.type = data.type;
          if (this.imageFileId) {
            this.imageFileUrl = window.Endpoints.imageServerUrl + this.imageFileId;
          }
          if (this.imageFileEnId) {
            this.imageFileEnUrl = window.Endpoints.imageServerUrl + this.imageFileEnId;
          }
          if (this.imageFileJaId) {
            this.imageFileJaUrl = window.Endpoints.imageServerUrl + this.imageFileJaId;
          }
        }
      });
    },
    async setBannerState(state) {
      return this.$axios
        .put(`/homepage/banners/${this.bannerId}/state`, {
          state,
        })
        .then((res) => {
          Toast.success("상태가 변경되었습니다");
          this.state = state;
        });
    },

    async onSubmit() {
      if (!this.imageFileId && !this.imageFileUrl) {
        Toast.error("이미지는 필수입니다");
        return;
      }
      const param = {
        imageFileId: this.imageFileId,
        imageFileEnId: this.imageFileEnId,
        imageFileJaId: this.imageFileJaId,
        link: this.link,
        type: this.type,
        startTime: this.startTime,
        endTime: this.endTime,
      };

      if (this.bannerId) {
        return this.$axios
          .put(`/homepage/banners/${this.bannerId}`, {
            ...param,
          })
          .then((res) => {
            Toast.success("배너가 수정되었습니다");
          });
      } else {
        for (const t of this.type) {
          param.type = this.types.filter((type) => type.type === t)[0].type;
          await this.$axios.post("/homepage/banners", {
            ...param,
          });
        }
        Toast.success("배너가 등록되었습니다");
      }
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.has-image {
  padding-top: 100px;
}
.artist-selection {
  margin-bottom: 20px;
}
.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}
</style>
